export default {
  methods: {
    async getInvestorAccount(investor_id) {
      let url = `/api/stp/v1/account/investorId/${investor_id}`;
      try {
        let response = await axios.get(url);
        return response.data;
      } catch (error) {
        return false;
      }
    },
    async getInvestorAccountStpClabe(investor_id){
      let account = await this.getInvestorAccount(investor_id);
      if(account === false || account === undefined || account === null){
        return null;
      }
      // se verifica si la cuenta esta en estatus created
      if(account.status === "created"){
        return account.stp_clabe;
      }
      else{
        return null;
      }
    }
  }
}
